import React, { useState, useEffect } from "react";

// react router
import { useHistory } from "react-router-dom";

// redux
import { connect } from "react-redux";

// includes
import {
	Body
} from "./includes";
import { addCustomer, getCustomerAddresses } from "utlis/Apis/Customers_API";

// react toastify
import { toast } from "react-toastify";

// app messages
import {
	ERROR_WHILE__NAME,
	UNKNOWN_ERROR_OCCURED,
} from "utlis/AppMessages/AppMessages";
import { createOrder, emptyCartItems } from "utlis/Apis/Cart_API";

// actions
import { emptyCart } from "redux/actions/actionCart";
import { setTempOrderId } from "redux/actions/actionAuth";
import { setGlobalLoading } from "redux/actions/actionCommon";
import { saveToLocalStorage } from "utlis/helpers/Common/CommonHelperFunctions";

function Checkout(props) {
	// props
	const {
		currentUser,
		commonToken,

		tempOrderId,
		emptyCart,

		guestUserEmail,
		setGlobalLoading,

		setTempOrderId
	} = props

	// consts
	const history = useHistory();
	const TEMP_ORDER_ID = `${new Date().getTime()}__${Math.random()}`
	const name_to_save_on_local_storage = `__toi_dd`

	// states
	const [allCheckoutDetails, setAllCheckoutDetails] = useState({})
	const [pageLoading, setPageLoading] = useState(false)

	const [userShippingAddress, setUserShippingAddress] = useState(null)
	const [userBillingAddress, setUserBillingAddress] = useState(null)

	// getting user address if he is logged in
	useEffect(() => {
		if (currentUser) {
			// enable global loading
			setGlobalLoading(true)

			// getting address data
			getCustomerAddresses(commonToken ?? "", currentUser.userId).then(res => {
				// disable global loading
				setGlobalLoading(false)

				const resData = res.data

				// if success
				if (resData.success) {
					const billingAddress = []
					const shippingAddress = []
					resData.data.forEach(item => {
						if (item.address_type === "Billing") {
							billingAddress.push({
								addressId: item?.address_id && item.address_id.toString(),
								addressType: item?.address_type && item.address_type.toString(),
								companyName: item?.shipping_company_name && item.shipping_company_name.toString(),
								countryId: item?.shipping_country && item.shipping_country.toString(),
								countryName: item?.country && item.country.toString(),
								stateId: item?.shipping_state && item.shipping_state.toString(),
								stateName: item?.state && item.state.toString(),
								cityId: item?.shipping_city && item.shipping_city.toString(),
								cityName: item?.city && item.city.toString(),
								zipCode: item?.shipping_zipcode && item.shipping_zipcode.toString(),
								firstName: item?.shipping_first_name && item.shipping_first_name.toString(),
								lastName: item?.shipping_last_name && item.shipping_last_name.toString(),
								address: item?.shipping_address && item.shipping_address.toString(),
								address1: item?.shipping_address1 && item.shipping_address1.toString(),
								phone: item?.shipping_mobile && item.shipping_mobile.toString(),
								isDefault: item?.is_default && item.is_default.toString(),
							})
						}
						if (item.address_type === "Shipping") {
							shippingAddress.push({
								addressId: item?.address_id && item.address_id.toString(),
								addressType: item?.address_type && item.address_type.toString(),
								companyName: item?.shipping_company_name && item.shipping_company_name.toString(),
								countryId: item?.shipping_country && item.shipping_country.toString(),
								countryName: item?.country && item.country.toString(),
								stateId: item?.shipping_state && item.shipping_state.toString(),
								stateName: item?.state && item.state.toString(),
								cityId: item?.shipping_city && item.shipping_city.toString(),
								cityName: item?.city && item.city.toString(),
								zipCode: item?.shipping_zipcode && item.shipping_zipcode.toString(),
								firstName: item?.shipping_first_name && item.shipping_first_name.toString(),
								lastName: item?.shipping_last_name && item.shipping_last_name.toString(),
								address: item?.shipping_address && item.shipping_address.toString(),
								address1: item?.shipping_address1 && item.shipping_address1.toString(),
								phone: item?.shipping_mobile && item.shipping_mobile.toString(),
								isDefault: item?.is_default && item.is_default.toString(),
							})
						}
					})

					// setting addresses
					setUserShippingAddress(shippingAddress)
					setUserBillingAddress(billingAddress)
				}

				// if error
				if (resData.error) {
					console.log("error in the getCustomerAddresses api ", resData.error);
				}

			}).catch(err => {
				console.log("error in the getCustomerAddresses api ", err);

				// disable global loading
				setGlobalLoading(false)
			})
		}
	}, [currentUser, commonToken])

	// final creating order
	const createOrderProcess = data => {
		if (data) {
			// creating order
			createOrder(commonToken ?? "", data).then(res => {
				const resData = res.data
				if (resData?.success) {
					emptyCartItems(commonToken ?? "", tempOrderId).then(res => {
						// disabling page loading
						setGlobalLoading(false)

						// empty the cart
						emptyCart()

						// replacing temp order id from the local with a new one
						saveToLocalStorage(name_to_save_on_local_storage, TEMP_ORDER_ID)
						// setting order id to the global store
						setTempOrderId(TEMP_ORDER_ID)

						history.push({
							pathname: "/cart-success",
							state: {
								orderId: resData.order_id
							}
						})
					}).catch(err => {
						console.log(`${ERROR_WHILE__NAME} createOrder`, err.message);

						// disabling page loading
						setGlobalLoading(false)
					})

					// dismissing all the previous toasts first
					toast.dismiss();

					// showing the error message
					toast.success("Order placed successfully", {
						autoClose: 2500,
						onClose: () => { },
					});
				}

				if (resData?.error) {
					// dismissing all the previous toasts first
					toast.dismiss();

					// showing the error message
					toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
						autoClose: 2500,
						onClose: () => {
							// disabling page loading
							setGlobalLoading(false)
						},
					});
				}
			}).catch(err => {
				// disabling page loading
				setGlobalLoading(false)

				console.log(`${ERROR_WHILE__NAME} createOrder`, err.message);

				// dismissing all the previous toasts first
				toast.dismiss();

				// showing the error message
				toast.error(UNKNOWN_ERROR_OCCURED, {
					autoClose: 2500,
					onClose: () => {
						// disabling page loading
						setGlobalLoading(false)
					},
				});
			})
		}
	}

	// calling create order function if all the required data is available
	useEffect(() => {
		if (
			allCheckoutDetails?.billingAddressDetails &&
			allCheckoutDetails?.shippingAddressDetails &&
			allCheckoutDetails?.shippingMethod &&
			allCheckoutDetails?.paymentDetails
		) { // if billng details exist then calling the
			setTimeout(() => {
				handleCreateOrder()
			}, 200);
		}
	}, [allCheckoutDetails])

	// create order information gethering
	const handleCreateOrder = () => {
		if (allCheckoutDetails) {
			// enabling page loading
			setGlobalLoading(true)

			// checking if the user is a new user then create one
			if (!currentUser) {
				const customerInfo = {
					email_verified: "0",
					status: "1",
					retailer_type: "",
					activate_bank_payment: "",
					activate_net30: "",
					email: guestUserEmail,
					license_number: "",
					business_license: "",
					first_name: allCheckoutDetails.shippingAddressDetails.shipping_first_name,
					middle_name: "",
					last_name: allCheckoutDetails.shippingAddressDetails.shipping_last_name,
					company_name: "",
					shipping_person: {
						address_type: "Shipping",
						...allCheckoutDetails.shippingAddressDetails
					},
					billing_person: allCheckoutDetails.billingAddressSameAsShippingAddress ? {
						address_type: "Billing",
						...allCheckoutDetails.shippingAddressDetails
					} : {
						address_type: "Billing",
						...allCheckoutDetails.billingAddressDetails
					},
					is_guest: 1
				}

				// adding customer api
				addCustomer("", customerInfo).then(res => {
					const resData = res.data

					// if request is success
					if (resData?.success) {
						// creatig order
						const requiredData = {
							temp_order_id: tempOrderId,
							customer_id: resData?.data?.user_id ?? resData.user_id,
							payment_processor: "AUTHORIZE.NET",
							card_number: allCheckoutDetails.paymentDetails.cardNumber,
							card_expiry_month: allCheckoutDetails.paymentDetails.expiryMonth,
							card_expiry_year: allCheckoutDetails.paymentDetails.expiryYear,
							card_cvv: allCheckoutDetails.paymentDetails.cvv,
							shipping_amount: "",
							coupon_code: "",
							coupon_discount: "",
							shipping_person: {
								address_type: "Shipping",
								...allCheckoutDetails.shippingAddressDetails
							},
							billing_person: allCheckoutDetails.billingAddressSameAsShippingAddress ? {
								address_type: "Billing",
								...allCheckoutDetails.shippingAddressDetails
							} : {
								address_type: "Billing",
								...allCheckoutDetails.billingAddressDetails
							},
						}

						// creating order
						createOrderProcess(requiredData)
					}

					// if request is not success
					if (resData?.error) {
						// dismissing all the previous toasts first
						toast.dismiss();

						// showing the error message
						toast.error(UNKNOWN_ERROR_OCCURED, {
							autoClose: 2500,
							onClose: () => { },
						});
					}
				}).catch(err => {
					// disabling page loading
					setGlobalLoading(false)

					console.log(`${ERROR_WHILE__NAME} addCustomer`, err.message);

					// dismissing all the previous toasts first
					toast.dismiss();

					// showing the error message
					toast.error(UNKNOWN_ERROR_OCCURED, {
						autoClose: 2500,
						onClose: () => { },
					});
				})
			} else { // if the user is an existing user
				// disabling page loading
				setPageLoading(false)

				const requiredData = {
					temp_order_id: tempOrderId,
					customer_id: currentUser.userId,
					payment_processor: "AUTHORIZE.NET",
					card_number: allCheckoutDetails.paymentDetails.cardNumber,
					card_expiry_month: allCheckoutDetails.paymentDetails.expiryMonth,
					card_expiry_year: allCheckoutDetails.paymentDetails.expiryYear,
					card_cvv: allCheckoutDetails.paymentDetails.cvv,
					shipping_amount: "",
					coupon_code: "",
					coupon_discount: "",
					shipping_person: {
						address_type: "Shipping",
						...allCheckoutDetails.shippingAddressDetails
					},
					billing_person: allCheckoutDetails.billingAddressSameAsShippingAddress ? {
						address_type: "Billing",
						...allCheckoutDetails.shippingAddressDetails
					} : {
						address_type: "Billing",
						...allCheckoutDetails.billingAddressDetails
					},
				}

				// creating order
				createOrderProcess(requiredData)
			}
		}
	}

	return (
		<div className="cart-main-outer-later-added pt-4">
			<div className="container">
				<Body
					pageLoading={pageLoading}
					allCheckoutDetails={allCheckoutDetails}
					setAllCheckoutDetails={data => setAllCheckoutDetails(data)}

					userBillingAddress={userBillingAddress}
					userShippingAddress={userShippingAddress}

					guestUserEmail={guestUserEmail}
				/>

				{/* <Footer /> */}
			</div>
		</div>
	);
}

const getDataFromStore = (state) => {
	return {
		currentUser: state.auth.currentUser,
		commonToken: state.auth.commonToken,
		tempOrderId: state.auth.tempOrderId,
	};
};

const dispatchActionsToProps = (dispatch) => {
	return {
		emptyCart: () => dispatch(emptyCart()),
		setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
		setTempOrderId: orderId => dispatch(setTempOrderId(orderId)),
	};
};

export default connect(getDataFromStore, dispatchActionsToProps)(Checkout);